export const apiFieldMapping: Record<string, string> = {
  email_address: 'extra_data->>"email_address"',
  path: 'extra_data->>"path"',
};
